"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.childTokensAreEmpty = exports.GenericTextComponent = void 0;
var react_1 = __importDefault(require("react"));
var textStyles_1 = require("../../../WidgetRegistry/Traits/Styleable/textStyles");
var classnames_1 = __importDefault(require("classnames"));
var RenderTokensHostContext_1 = require("@CommonFrontend/ContentTokens/RenderTokensHost/RenderTokensHostContext");
var GenericTextComponent = function (_a) {
    var attributes = _a.attributes, style = _a.style, htmlTag = _a.htmlTag, css = _a.css, childTokens = _a.childTokens;
    var RenderTokensHost = (0, RenderTokensHostContext_1.useRenderTokensHostContext)().RenderTokensHost;
    var computeForegroundColor = undefined;
    var styles = __assign(__assign({}, attributes.style), (0, textStyles_1.maybeAssignComputedForegroundColor)({
        computeForegroundColor: computeForegroundColor,
        foregroundStyle: style,
        foregroundColorVar: css.vars.color,
    }));
    var renderEmptyBreak = (0, exports.childTokensAreEmpty)(childTokens);
    var children = renderEmptyBreak ? react_1.default.createElement("br", null) : react_1.default.createElement(RenderTokensHost, { tokens: childTokens });
    return react_1.default.createElement(htmlTag, __assign(__assign({}, attributes), { className: (0, classnames_1.default)(attributes.className, css.widget), style: styles }), children);
};
exports.GenericTextComponent = GenericTextComponent;
var childTokensAreEmpty = function (childTokens) {
    var _a, _b;
    return (childTokens.length === 0 ||
        (childTokens.length === 1 && ((_a = childTokens[0]) === null || _a === void 0 ? void 0 : _a.subType) === "text" && ((_b = childTokens[0]) === null || _b === void 0 ? void 0 : _b["text"]) === ""));
};
exports.childTokensAreEmpty = childTokensAreEmpty;
